import { useState } from 'react';
import IpsSelector from '../../../../Controls/Modals/IpsSelector/IpsSelector';
import SelectField from '../SelectField/SelectField';
import Button from '../Button/Button';
import SelectStyles from '../Select/Select.module.css';
import styles from './SelectIpField.module.css';

const SelectIpField = ({ field, changed, maxIps }) => {
    const [showHostsIpsSelectorModal, setShowHostsIpsSelectorModal] = useState(false);

    const saveSubnets = (subnets) => {
        const values = subnets.map((subnet) => {
            const mask = subnet.mask && subnet.mask !== '32' ? `/${subnet.mask}` : '';
            return `${subnet.address}${mask}`;
        });
        changed(field.id, values);
        setShowHostsIpsSelectorModal(false);
    };

    const modalSelectedIps = field.value.map((subnet) => {
        const [address, mask] = subnet.split('/');
        return { address, mask: mask || '32', excluded: false };
    });
    const selectedIps = field.value.map((subnet) => {
        return { value: subnet, label: subnet, className: SelectStyles.fixedOption };
    });

    return (
        <div>
            <div className={styles.selectContainer}>
                <SelectField field={field} options={selectedIps} multichoice={true} clearable={false}></SelectField>
                <div className={styles.updateBtn}>
                    <Button onClick={() => setShowHostsIpsSelectorModal(true)}>Update</Button>
                </div>
            </div>
            {showHostsIpsSelectorModal && (
                <IpsSelector
                    selectedIps={modalSelectedIps}
                    showModal={showHostsIpsSelectorModal}
                    handleCloseModal={() => setShowHostsIpsSelectorModal(false)}
                    saveIps={saveSubnets}
                    isEditor={true}
                    maxIps={maxIps}
                />
            )}
        </div>
    );
};

export default SelectIpField;
